// Utils
import { useState, useEffect } from "react";
import { useProductData } from "@/zustand/productStore";

export const usePaymentAvailability = () => {
  const [isApplePayAvailable, setIsApplePayAvailable] =
    useState<boolean>(false);
  const [isGooglePayAvailable, setIsGooglePayAvailable] =
    useState<boolean>(false);

  const productData = useProductData() || {};
  const { paymentsConfig } = productData || {};

  useEffect(() => {
    // Check Apple Pay availability
    try {
      if (window.ApplePaySession && window.ApplePaySession.canMakePayments()) {
        setIsApplePayAvailable(true);
      }
    } catch (err) {
      console.error("Apple Pay availability check failed:", err);
    }

    // Check Google Pay availability
    const checkGooglePay = () => {
      if (!window.google || !window.google.payments) return;

      const client = new window.google.payments.api.PaymentsClient({
        environment: "PRODUCTION",
      });

      const baseCardPaymentMethod = {
        type: "CARD",
        parameters: {
          allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
          allowedCardNetworks: ["VISA", "MASTERCARD", "AMEX", "DISCOVER"],
        },
        tokenizationSpecification: {
          type: "PAYMENT_GATEWAY",
          parameters: {
            gateway: paymentsConfig?.gpayGateway,
            gatewayMerchantId: paymentsConfig?.gpayGatewayMerchant,
          },
        },
      };

      client
        .isReadyToPay({
          apiVersion: 2,
          apiVersionMinor: 0,
          allowedPaymentMethods: [baseCardPaymentMethod],
        })
        .then((res: any) => {
          setIsGooglePayAvailable(res.result);
        })
        .catch((err: any) => {
          console.error(err);
          setIsGooglePayAvailable(false);
        });
    };

    if (window.google && window.google.payments) {
      checkGooglePay();
    } else {
      const s = document.createElement("script");
      s.src = "https://pay.google.com/gp/p/js/pay.js";
      s.async = true;
      s.onload = checkGooglePay;
      document.head.appendChild(s);
    }
  }, []);

  return { isApplePayAvailable, isGooglePayAvailable };
};
